export default {
  check_status: {
    verified: 'Geverifieerd',
    pending: 'In afwachting',
    failed: 'Mislukt',
    not_applicable: 'Niet nodig',
    required: 'Vereist',
  },
  records: {
    type: 'Type',
    name: 'Naam',
    value: 'Waarde',
    status: 'Status',
    certificate: 'Certificaat',
    certificate_hint: 'Wordt automatisch uitgegeven zodra de records hierboven zijn gevonden.',
    full_name: 'Volledige naam:',
  },
  check_hint: {
    found: 'In plaats daarvan is {{values}} gevonden. Vervang dit door de weergegeven waarde.',
    missing: 'Dit record is niet gevonden.',
    certificate:
      'Het certificaat kon niet worden uitgegeven. Corrigeer de hierboven gemarkeerde records en controleer opnieuw.',
    certificate_unknown:
      'Het certificaat kon niet worden uitgegeven. Controleer het later opnieuw en neem contact op met support als het zo blijft.',
    regressed: 'Dit record was eerder geverifieerd en wordt niet meer gevonden.',
    technical: 'Technisch detail: {{error}}',
    held_by_another_project:
      '{{name}} wordt gebruikt door een andere website op Vercel en kan bezoekers daarom niet doorsturen naar de shop op www.{{name}}. Wilt u dat {{name}} ook de shop opent, verwijder het domein dan eerst van die andere website.',
    certificate_pending: {
      not_attached: 'Bezig: we voegen het domein aan onze kant toe.',
      awaiting_dns: 'Bezig: het certificaat wordt uitgegeven zodra de records hierboven zijn gevonden.',
      awaiting_certificate:
        'Bezig: de records wijzen naar ons en het certificaat wordt uitgegeven. Dit duurt meestal een paar minuten.',
    },
    certificate_failed: {
      ownership_proof_required:
        '{{name}} is ook gekoppeld aan een ander Vercel-account. Om aan te tonen dat het domein van u is, voegt u ook de TXT-records hieronder toe bij de DNS-provider en controleert u daarna opnieuw.',
      held_by_another_project:
        'Een andere website op Vercel gebruikt {{name}} al. Verwijder het domein eerst van die website en controleer daarna opnieuw — of gebruik een ander domein.',
      dns_correct_but_unconfigured:
        'De records hierboven kloppen, maar iets anders op {{name}} blokkeert het certificaat. Verwijder alle AAAA-records op deze naam, zet een proxy ervoor uit (zoals de oranje wolk bij Cloudflare) en zorg dat geen CAA-record Let’s Encrypt uitsluit. Controleer daarna opnieuw.',
      name_mismatch:
        '{{name}} antwoordt met een certificaat voor {{names}}. Zorg dat de records hierboven de enige op {{name}} zijn; als dat zo is, neem dan contact op met support.',
      name_mismatch_unnamed:
        '{{name}} antwoordt met een certificaat voor een andere naam. Zorg dat de records hierboven de enige op {{name}} zijn; als dat zo is, neem dan contact op met support.',
      expired:
        'Het certificaat is verlopen en niet vernieuwd. We zijn gewaarschuwd en zijn ermee bezig — u hoeft voorlopig niets te doen.',
      expiring:
        'Het certificaat verloopt binnenkort en is nog niet vernieuwd. We zijn ermee bezig — u hoeft voorlopig niets te doen.',
      attach_refused:
        'Onze hostingprovider heeft geweigerd {{name}} aan onze kant toe te voegen. We zijn gewaarschuwd en zoeken het uit — bij de DNS-provider hoeft voorlopig niets te veranderen.',
    },
    certificate_overdue: {
      not_attached:
        'Na 48 uur kon het domein aan onze kant nog steeds niet worden toegevoegd. Neem contact op met support.',
      awaiting_dns:
        'Na 48 uur wordt nog steeds gewacht op de records hierboven. Corrigeer de hierboven gemarkeerde records en controleer opnieuw.',
      awaiting_dns_records_verified:
        'Na 48 uur nog steeds niet uitgegeven, hoewel de records hierboven zijn geverifieerd. Neem contact op met support.',
      awaiting_certificate:
        'De records wijzen naar ons, maar het certificaat is na 48 uur nog steeds niet uitgegeven. Neem contact op met support.',
    },
    certificate_dates: {
      valid_until: 'Geldig tot {{date}}.',
      expires_on: 'Verloopt op {{date}}.',
      expired_on: 'Verlopen op {{date}}.',
    },
  },
};
